import api from "../axios";
import Api from "../Api";

export async function getGroup() {
  const response = await api
    .get(`${Api.request.URL}/private-sale-group/`)
    .then((res) => {
      return res.data.data;
    })
    .catch((error) => {
      return error.response.data.errors;
    });
  return response;
}



export async function findArtist(search) {
  const response = await api
    .get(`${Api.request.URL}/lot/getArtist?search=${search}`)
    .then((res) => {
      return res.data.data;
    })
    .catch((error) => {
      return error.response.data.errors;
    });
  return response;
}



export async function getCategory() {
  const response = await api
    .get(`${Api.request.URL}/category/`)
    .then((res) => {
      return res.data.data;
    })
    .catch((error) => {
      return error.response.data.errors;
    });
  return response;
}



export async function getGroupByAll() {
  const response = await api
    .get(`${Api.request.URL}/private-sale-group/`)
    .then((res) => {
      return res.data.data;
    })
    .catch((error) => {
      return error.response.data.errors;
    });
  return response;
}

export async function getGroupFindByID(id) {
  const response = await api
    .get(`${Api.request.URL}/private-sale-group/${id}`)
    .then((res) => {
      return res.data.data;
    })
    .catch((error) => {
      return error.response.data.errors;
    });
  return response;
}

export async function uploadBanner(data) {
  // console.log("uploader: ",data)
  let formData = new FormData();
 formData.append("id", data.id);
  formData.append("group_desc", data.group_desc);
  formData.append("url", data.url);
  formData.append("files", data.file);

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${Api.request.URL}/private-sale-group/upload`,
    data: formData,
  };

  const response = await api
    .request(config)
    .then((response) => {
     // alert.success(response.data.msg);
    return response.data.msg;
    })
    .catch((error) => {
      console.log(error);
    });
  return response;
}
